function eventConsole(eventName, eventData = {}) {
  const css1 =
    "background: black; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;";
  const css2 =
    "background: #f44a4f; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;";
  console.log("%cEvent:%c " + eventName, css1, css2, eventData);
}

class BundleManager {
  constructor() {
    this.bundleOptions = document.querySelectorAll(".bundle-option");
    this.addToCartButton = document.getElementById("add-bundle-to-cart-btn");
    this.resetSelectionButton = document.getElementById("reset-selection-btn");
    this.selectedItemsSummary = document.getElementById(
      "selected-items-summary"
    );
    this.remainingItemsCount = document.getElementById("remaining-items-count");
    this.progressBarFill = document.getElementById("progress-bar-fill");
    this.progressBarMarker = document.getElementById("progress-bar-marker");
    this.productCards = document.querySelectorAll(".product-card");
    this.enforceStockLimit = false;
    this.isUpdating = false;

    this.initializeStockInfo();
    this.initDefaultOption();

    // Icône pour fermer le résumé, avec balise HTML si nécessaire
    // this.svgCloseIcon = '<div style="font-size: 44px; line-height: 0; color: #1c1c1c;">-</div>';

    // Icône SVG pour fermer le résumé
    this.svgCloseIcon =
      '<svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M6.64 17.36L12 11l5.36 6.36L20 16l-8-8-8 8z" /></svg>';

    // Références aux éléments
    this.summaryToggleBtn = document.getElementById("summary-content-btn");
    this.summaryIcon = document.getElementById("summary-icon");
    this.overlayBackground = document.querySelector(".overlay-background");

    // Initialisation des écouteurs d'événements
    this.initEventListeners();
    this.updateInterface();
    this.updateProductPrices();
    this.updateStep2Title(this.maxBundleQuantity);
  }

  updateStep2Title(quantity) {
    const step2Title = document.querySelector("#selection-step-2 h4");
    if (step2Title) {
      const step2TitleQuantity = step2Title.querySelector("[data-quantity]");
      if (step2TitleQuantity) step2TitleQuantity.textContent = quantity;
    }
  }

  initializeStockInfo() {
    if (!this.enforceStockLimit) {
      document.querySelectorAll(".stock-info").forEach((stockElement) => {
        stockElement.style.display = "none";
      });
    }
  }

  initDefaultOption() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = urlParams.get("variant_id");

    if (variantIdFromUrl) {
      const optionFromUrl = Array.from(this.bundleOptions).find(
        (option) => option.dataset.variantId === variantIdFromUrl
      );

      if (optionFromUrl) {
        this.bundleOptions.forEach((option) =>
          option.classList.remove("selected")
        );
        optionFromUrl.classList.add("selected");

        this.maxBundleQuantity = parseInt(optionFromUrl.dataset.quantity);
        this.currentBundleQuantity = 0;
        this.selectedVariantId = optionFromUrl.dataset.variantId;
        this.setPrices(
          optionFromUrl.dataset.price,
          optionFromUrl.dataset.comparePrice
        );

        // 🆕 On récupère aussi l'incrément
        this.incrementStep = parseInt(optionFromUrl.dataset.increment) || 1;

        console.log(
          `Option pré-sélectionnée avec variant_id=${variantIdFromUrl}`
        );
        return;
      } else {
        console.warn(
          `Aucune option trouvée pour variant_id=${variantIdFromUrl}. Utilisation de l'option par défaut.`
        );
      }
    }

    const defaultOption = document.querySelector(".bundle-option.selected");
    if (defaultOption) {
      this.maxBundleQuantity = parseInt(defaultOption.dataset.quantity);
      this.currentBundleQuantity = 0;
      this.selectedVariantId = defaultOption.dataset.variantId;
      this.setPrices(
        defaultOption.dataset.price,
        defaultOption.dataset.comparePrice
      );

      // ✅ Et ici aussi on initialise correctement l'incrément
      this.incrementStep = parseInt(defaultOption.dataset.increment) || 1;

      console.log("Option sélectionnée par défaut.");
    } else {
      console.error(
        "Aucune option de bundle sélectionnée par défaut ou disponible."
      );
    }
  }

  setPrices(price, comparePrice) {
    this.bundlePrice = parseFloat(price);
    this.bundleComparePrice = parseFloat(comparePrice) || this.bundlePrice;
    this.pricePerPerfume = this.bundlePrice / this.maxBundleQuantity;
    this.originalPricePerPerfume =
      this.bundleComparePrice / this.maxBundleQuantity;
  }

  initEventListeners() {
    this.bundleOptions.forEach((option) => {
      option.addEventListener("click", () => this.selectBundleOption(option));
    });

    document.addEventListener("click", (event) => this.handleClickEvent(event));
    document.addEventListener("input", (event) => {
      if (event.target.classList.contains("quantity-input"))
        this.updateQuantity(event.target);
    });
    this.addToCartButton.addEventListener("click", () =>
      this.handleAddToCart()
    );
    this.resetSelectionButton.addEventListener("click", () =>
      this.resetSelection()
    );

    if (this.summaryToggleBtn) {
      this.summaryToggleBtn.addEventListener("click", () =>
        this.toggleSummaryContent()
      );
    }

    if (this.overlayBackground) {
      this.overlayBackground.addEventListener("click", () =>
        this.toggleSummaryContent()
      );
    }

    document.querySelectorAll(".product-image-clickable").forEach((image) => {
      image.addEventListener("click", (event) => this.handleImageClick(event));
    });

    // Écouteur pour l'icône du résumé
    if (this.summaryIcon) {
      this.summaryIcon.addEventListener("click", () =>
        this.toggleSummaryContent()
      );
    }

    // Écouteurs pour les bulles d'information
    this.infoBubbles = document.querySelectorAll(".product-info-bubble");

    this.infoBubbles.forEach((bubble) => {
      bubble.addEventListener("click", (event) =>
        this.handleInfoBubbleClick(event, bubble)
      );
    });
  }

  handleInfoBubbleClick(event, bubble) {
    const productId = event.currentTarget.getAttribute("data-product-id");
    const productCard = document.querySelector(
      `.product-card[data-product-id="${productId}"]`
    );
    const productDescription = productCard.querySelector(
      ".product-description"
    ).innerHTML;
    this.showProductInfoPopup(bubble, productDescription);
  }

  showProductInfoPopup(bubble, productDescription) {
    const popup = document.getElementById("product-info-popup");
    const popupDescription = popup.querySelector(".popup-description");
    const closeBtn = popup.querySelector(".close-popup");

    const stockIndicatorElement = bubble.querySelector("stock-indicator");

    // Injecter la description du produit dans la popup
    popupDescription.innerHTML = productDescription;

    if (stockIndicatorElement) {
      const element = stockIndicatorElement.cloneNode(true);
      element.removeAttribute("hidden");
      popupDescription.appendChild(element);
    }

    // Afficher la popup
    popup.style.display = "flex";

    // Gérer la fermeture de la popup
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
    });

    // Fermer la popup en cliquant en dehors du contenu
    popup.addEventListener("click", (event) => {
      if (event.target === popup) {
        popup.style.display = "none";
      }
    });
  }

  handleImageClick(event) {
    const parent = event.target.closest(".product-card");
    const quantityInput = parent.querySelector(".quantity-input");

    if (!parent.hasAttribute("data-added")) {
      this.replaceAddButtonWithQuantitySelector(parent);
      parent.setAttribute("data-added", "true");
      quantityInput.value = 0; // Initialisez la quantité à 0 lors du premier clic
    }

    const incrementStep = this.getIncrementStep();
    let currentQuantity = parseInt(quantityInput.value) || 0;
    let newQuantity = currentQuantity + incrementStep;

    // Vérifiez si la nouvelle quantité dépasse la quantité maximale du lot
    if (
      this.computeTotalSelectedQuantity() + incrementStep >
      this.maxBundleQuantity
    ) {
      newQuantity = currentQuantity; // Ne pas augmenter si on atteint la limite
    }

    quantityInput.value = newQuantity;
    this.updateQuantity(quantityInput);
  }

  toggleSummaryContent() {
    if (window.innerWidth > 768) {
      return; // Ne rien faire si l'écran est plus large qu'une tablette
    }

    const summaryContent = document.querySelector(".summary-content");
    const addToCartButton = document.getElementById("add-bundle-to-cart-btn");
    const summaryTitle = document.querySelector(
      ".summary-content-block .bloc_step h4"
    );
    const blocStep = document.querySelector(
      ".summary-content-block .bloc_step"
    );
    const overlay = document.querySelector(".overlay-background");

    if (summaryContent) {
      const isHidden =
        summaryContent.style.display === "none" ||
        summaryContent.style.display === "";

      if (isHidden) {
        // Ouvrir le résumé
        summaryContent.style.display = "block";
        overlay.style.display = "block";

        if (summaryTitle) {
          summaryTitle.style.display = "block";
          blocStep.classList.add("justify-between");
        }

        summaryContent.scrollIntoView({ behavior: "smooth" });

        if (addToCartButton) {
          addToCartButton.style.display = "block";
        }

        // Cacher le message
        const remainingProductsMessage = document.getElementById(
          "remaining-products-message"
        );
        if (remainingProductsMessage) {
          remainingProductsMessage.style.display = "none";
        }

        // Cacher le bouton et afficher l'icône
        this.summaryToggleBtn.style.display = "none";
        this.summaryIcon.style.display = "block";
        this.summaryIcon.innerHTML = this.svgCloseIcon;
      } else {
        // Fermer le résumé
        summaryContent.style.display = "none";
        overlay.style.display = "none";

        if (summaryTitle) {
          summaryTitle.style.display = "none";
          blocStep.classList.remove("justify-between");
        }

        // Afficher le message
        const remainingProductsMessage = document.getElementById(
          "remaining-products-message"
        );
        if (remainingProductsMessage) {
          remainingProductsMessage.style.display = "block";
        }

        // Afficher le bouton et cacher l'icône
        this.summaryToggleBtn.style.display = "block";
        this.summaryIcon.style.display = "none";

        if (addToCartButton) {
          addToCartButton.style.display = "none";
        }
      }
    }
  }

  handleClickEvent(event) {
    if (
      event.target.classList.contains("add-to-selection-btn") &&
      !event.target.classList.contains("disabled")
    ) {
      this.handleAddToSelection(event);
    } else if (event.target.classList.contains("quantity-increment-btn")) {
      this.handleIncrementQuantity(event);
    } else if (event.target.classList.contains("quantity-decrement-btn")) {
      this.handleDecrementQuantity(event);
    }
  }

  async handleAddToCart() {
    if (!this.addToCartButton.classList.contains("disabled")) {
      const items = this.getSelectedItems();
      this.setLoadingState(true);

      const properties = items.reduce((acc, item) => {
        acc[item.name] = item.quantity;
        return acc;
      }, {});

      const itemsData = [
        {
          id: this.selectedVariantId,
          quantity: 1,
          properties: properties,
        },
      ];

      try {
          this.insuranceId = document.querySelector(
            ".insurance-product-id"
          )?.value;
          if (this.insuranceId) {
            const itemDataInsurance = {
              id: this.insuranceId,
              quantity: 1,
            };
            itemsData.push(itemDataInsurance);
          }
      } catch (error) {
        console.error(
          "Erreur lors de l'ajout au panier de l'assurance transport",
          { error: error }
        );
      }

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: itemsData,
            sections: sectionsToBundle.join(","),
          }),
        });

        const responseJson = await response.json();

        if (response.ok) {
          localStorage.setItem(
            "trackAddToCartEvent",
            JSON.stringify({
              eventName: "Product Added to Cart",
              eventData: {
                productId: this.selectedVariantId,
                items: items,
                totalQuantity: this.currentBundleQuantity,
                page: window.location.href,
                time: new Date().toLocaleTimeString(),
              },
            })
          );

          const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
          const cartContent = await cartResponse.json();
          cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent,
              },
            })
          );
          this.resetSelection();
          this.setLoadingState(false);
          if (
            window.themeVariables.settings.cartType === "page" ||
            window.themeVariables.settings.pageType === "cart"
          ) {
            return (window.location.href = `${Shopify.routes.root}cart`);
          }
        } else {
          const errData = await response.json();
          throw new Error(errData.message || errData.description);
        }
      } catch (error) {
        console.error("Erreur lors de l'ajout au panier :", error);
        this.showToast(window.themeVariables.strings.packBuilderAddToCartError);
        this.setLoadingState(false);
      }
    }
  }


  getSelectedItems() {
    return Array.from(
      this.selectedItemsSummary.querySelectorAll(".summary-item")
    ).map((item) => ({
      quantity: parseInt(item.querySelector(".quantity-input").value),
      name: item.querySelector(".summary-product-name").textContent,
      productId: item.getAttribute("data-product-id"),
    }));
  }

  selectBundleOption(option) {
    // Réinitialisation et sélection de l'option
    this.resetSelection();
    this.bundleOptions.forEach((opt) => opt.classList.remove("selected"));
    option.classList.add("selected");

    // Récupération des données de l'option
    this.selectedVariantId = option.dataset.variantId;
    this.maxBundleQuantity = parseInt(option.dataset.quantity);

    // Ici, on récupère directement le pas d'incrémentation depuis le champ méta
    this.incrementStep = parseInt(option.dataset.increment) || 1;

    // Mise à jour des prix et de l'interface
    this.setPrices(option.dataset.price, option.dataset.comparePrice);
    this.updateStep2Title(this.maxBundleQuantity);
    this.updateInterface();
    this.updateProductPrices();
    this.updateSummaryPrices();

    try {
      // Déclenche un événement pour d'autres traiements
      document.documentElement.dispatchEvent(
        new CustomEvent("pack-builder-variant:change", {
          bubbles: true,
          detail: {
            variantPrice: option.dataset.price,
          },
        })
      );
    } catch (error) {
      console.error(
        "Erreur lors de la diffusion de l'événement de changement de variante du pack builder.",
        { error: error }
      );
    }
  }

  formatPrice(price) {
    return price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
  }

  getPriceHtml(originalPrice, currentPrice) {
    return originalPrice > currentPrice
      ? `<span class="product-price-before">${this.formatPrice(
          originalPrice
        )}€</span><span class="product-price-after">${this.formatPrice(
          currentPrice
        )}€</span>`
      : `<span class="product-price-after">${this.formatPrice(
          currentPrice
        )}€</span>`;
  }

  updateProductPrices() {
    this.productCards.forEach((card) => {
      const productPriceElement = card.querySelector(".product-price");

      if (productPriceElement) {
        const originalPrice =
          parseFloat(card.getAttribute("data-product-compare-price")) ||
          parseFloat(card.getAttribute("data-product-price"));
        productPriceElement.innerHTML = this.getPriceHtml(
          originalPrice,
          this.pricePerPerfume
        );
      }
    });
  }

  updateSummaryPrices() {
    this.selectedItemsSummary
      .querySelectorAll(".summary-item")
      .forEach((item) => {
        const summaryPriceElement = item.querySelector(".summary-price");
        const originalPrice =
          parseFloat(item.getAttribute("data-product-compare-price")) ||
          parseFloat(item.getAttribute("data-product-price"));
        summaryPriceElement.innerHTML = this.getPriceHtml(
          originalPrice,
          this.pricePerPerfume
        );
      });
  }

  handleAddToSelection(event) {
    const parent = event.target.closest(".product-card");

    if (this.currentBundleQuantity >= this.maxBundleQuantity) {
      return;
    }

    if (this.currentBundleQuantity < this.maxBundleQuantity) {
      this.replaceAddButtonWithQuantitySelector(parent);
      parent.querySelector(".quantity-input").value = this.getIncrementStep();
      this.updateQuantity(parent.querySelector(".quantity-input"));
    }
  }

  handleIncrementQuantity(event) {
    const quantityInput = event.target.previousElementSibling;
    const parent =
      quantityInput.closest(".product-card") ||
      quantityInput.closest(".summary-item");
    const variantInventory =
      parseInt(parent.getAttribute("data-variant-inventory")) || Infinity;
    const incrementStep = this.getIncrementStep();
    let currentQuantity = parseInt(quantityInput.value) || 0;

    if (
      this.computeTotalSelectedQuantity() + incrementStep >
      this.maxBundleQuantity
    ) {
      return; // Ne pas augmenter si on atteint la limite
    }

    currentQuantity += incrementStep;
    quantityInput.value =
      this.enforceStockLimit && currentQuantity > variantInventory
        ? variantInventory
        : currentQuantity;
    this.updateQuantity(quantityInput);
  }

  handleDecrementQuantity(event) {
    const quantityInput = event.target.nextElementSibling;
    const decrementStep = this.getIncrementStep();
    let currentQuantity = parseInt(quantityInput.value) || 0;

    currentQuantity -= decrementStep;
    quantityInput.value = currentQuantity > 0 ? currentQuantity : 0;
    this.updateQuantity(quantityInput);
  }

  getIncrementStep() {
    return this.incrementStep || 1;
  }

  replaceAddButtonWithQuantitySelector(parent) {
    parent.querySelector(".add-to-selection-btn").style.display = "none";
    parent.querySelector(".quantity-control-wrapper").style.display = "flex";
    parent.setAttribute("data-added", "true");

    // Cacher la bulle d'information
    const infoBubble = parent.querySelector(".product-info-bubble");
    if (infoBubble) {
      infoBubble.style.display = "none";
    }
  }

  resetProductCard(productCard) {
    const addToSelectionBtn = productCard.querySelector(
      ".add-to-selection-btn"
    );
    const quantityControlWrapper = productCard.querySelector(
      ".quantity-control-wrapper"
    );
    const quantityInput = productCard.querySelector(".quantity-input");
    const quantityBubble = productCard.querySelector(
      ".product-quantity-bubble"
    );
    const infoBubble = productCard.querySelector(".product-info-bubble");

    if (addToSelectionBtn) addToSelectionBtn.style.display = "block";
    if (quantityControlWrapper) quantityControlWrapper.style.display = "none";
    if (quantityInput) quantityInput.value = 0;
    if (quantityBubble) {
      quantityBubble.textContent = "";
      quantityBubble.style.display = "none";
    }
    if (infoBubble) {
      infoBubble.style.display = "flex"; // Afficher à nouveau la bulle d'information
    }

    productCard.removeAttribute("data-added");

    // Retirer la classe CSS de sélection
    this.updateProductCardStyle(productCard, false);
  }

  addQuantityBubble(parent, quantity) {
    const bubble = parent.querySelector(".product-quantity-bubble");
    bubble.textContent = quantity > 0 ? quantity : "";
    bubble.style.display = quantity > 0 ? "flex" : "none";
  }

  updateQuantity(input) {
    const parent =
      input.closest(".product-card") || input.closest(".summary-item");
    let quantity = parseInt(input.value);
    quantity = isNaN(quantity) || quantity < 0 ? 0 : quantity;

    const variantInventory =
      parseInt(parent.getAttribute("data-variant-inventory")) || Infinity;
    quantity =
      this.enforceStockLimit && quantity > variantInventory
        ? variantInventory
        : quantity;

    input.value = quantity;

    // Synchroniser les quantités avant de recalculer la quantité totale
    this.syncQuantitiesAcrossViews(parent, quantity);

    // Recalculez la quantité totale sélectionnée
    this.currentBundleQuantity = this.computeTotalSelectedQuantity();

    // Vérifiez si la nouvelle quantité totale dépasse la quantité maximale autorisée
    if (this.currentBundleQuantity > this.maxBundleQuantity) {
      const allowedQuantity =
        quantity - (this.currentBundleQuantity - this.maxBundleQuantity);
      quantity = allowedQuantity >= 0 ? allowedQuantity : 0;
      input.value = quantity;
      // Synchroniser à nouveau les quantités après ajustement
      this.syncQuantitiesAcrossViews(parent, quantity);
      this.currentBundleQuantity = this.computeTotalSelectedQuantity();
    }

    // Mettre à jour le résumé et l'interface
    this.updateSummary(parent, quantity);
    this.updateInterface();
    this.updateSummaryPrices();

    // Mettre à jour le style de la carte produit
    const productId = parent.getAttribute("data-product-id");
    if (parent.classList.contains("product-card")) {
      this.updateProductCardStyle(parent, quantity > 0);
    } else if (parent.classList.contains("summary-item")) {
      const productCard = document.querySelector(
        `.product-card[data-product-id="${productId}"]`
      );
      if (productCard) {
        this.updateProductCardStyle(productCard, quantity > 0);
      }
    }

    if (quantity === 0) {
      this.resetProductCard(parent);
    }
  }

  computeTotalSelectedQuantity() {
    let total = 0;
    this.productCards.forEach((card) => {
      const quantityInput = card.querySelector(".quantity-input");
      let quantity = parseInt(quantityInput.value) || 0;
      total += quantity;
    });
    return total;
  }

  syncQuantitiesAcrossViews(parent, quantity) {
    const productId = parent.getAttribute("data-product-id");

    if (parent.classList.contains("product-card")) {
      const summaryItem = document.querySelector(
        `#selected-items-summary .summary-item[data-product-id="${productId}"]`
      );
      if (summaryItem) {
        summaryItem.querySelector(".quantity-input").value = quantity;
        if (quantity === 0) {
          summaryItem.remove();
        }
      }
      this.addQuantityBubble(parent, quantity);
      if (quantity === 0) {
        this.resetProductCard(parent);
      }
    } else if (parent.classList.contains("summary-item")) {
      const productCard = document.querySelector(
        `.product-card[data-product-id="${productId}"]`
      );
      if (productCard) {
        productCard.querySelector(".quantity-input").value = quantity;
        this.addQuantityBubble(productCard, quantity);
        if (quantity === 0) {
          this.resetProductCard(productCard);
        }
      }
      if (quantity === 0) {
        parent.remove();
      }
    }
  }

  updateSummary(element, quantity) {
    const productId = element.getAttribute("data-product-id");
    const productName = element.querySelector(".product-title")
      ? element.querySelector(".product-title").textContent
      : element.querySelector(".summary-product-name").textContent;
    const productImage =
      element.getAttribute("data-product-image") ||
      element.querySelector("img").src;
    const originalPrice =
      parseFloat(element.getAttribute("data-product-compare-price")) ||
      parseFloat(element.getAttribute("data-product-price"));
    const currentPrice = this.pricePerPerfume;

    // Récupérer le inspiration_label depuis l'élément caché
    let inspirationLabel = "";
    if (element.classList.contains("product-card")) {
      const inspirationElement = element.querySelector(
        ".product-card__inspiration"
      );
      if (inspirationElement) {
        inspirationLabel = inspirationElement.innerHTML;
      }
    } else if (element.classList.contains("summary-item")) {
      const productCard = document.querySelector(
        `.product-card[data-product-id="${productId}"]`
      );
      if (productCard) {
        const inspirationElement = productCard.querySelector(
          ".product-card__inspiration"
        );
        if (inspirationElement) {
          inspirationLabel = inspirationElement.innerHTML;
        }
      }
    }

    let summaryItem = document.querySelector(
      `#selected-items-summary .summary-item[data-product-id="${productId}"]`
    );
    const priceHtml = this.getPriceHtml(originalPrice, currentPrice);

    if (quantity > 0) {
      if (!summaryItem) {
        summaryItem = document.createElement("div");
        summaryItem.className = "summary-item";
        summaryItem.setAttribute("data-product-id", productId);
        summaryItem.setAttribute("data-product-compare-price", originalPrice);
        summaryItem.innerHTML = `
          <div class="summary-product-left">
            <img src="${productImage}" alt="${productName}">
            <div class="summary-product-header">
              <span class="summary-product-name">${productName}</span>
              ${
                inspirationLabel
                  ? `<div class="summary-inspiration-label">${inspirationLabel}</div>`
                  : ""
              }
            </div>
          </div>
          <div class="summary-product-footer">
            <span class="summary-price">${priceHtml}</span>
            <div class="summary-quantity-controls">
              <button class="quantity-decrement-btn" aria-label="Diminuer la quantité">-</button>
              <input type="number" class="quantity-input" value="${quantity}" min="0" aria-label="Quantité" readonly>
              <button class="quantity-increment-btn" aria-label="Augmenter la quantité">+</button>
            </div>
          </div>`;
        this.selectedItemsSummary.appendChild(summaryItem);
      } else {
        summaryItem.querySelector(".quantity-input").value = quantity;
        summaryItem.querySelector(".summary-price").innerHTML = priceHtml;
      }
    } else if (summaryItem) {
      summaryItem.remove();
    }
  }

  updateInterface() {
    const remaining = this.maxBundleQuantity - this.currentBundleQuantity;
    let remainingText =
      window.themeVariables.strings.packBuilderRemainingFragranceSingular;
    if (remaining > 1) {
      remainingText =
        window.themeVariables.strings.packBuilderRemainingFragrancePlural;
    }
    this.remainingItemsCount.textContent = `${remaining} ${remainingText}`;
    this.toggleAddToCartButton();

    const incrementButtons = document.querySelectorAll(
      ".quantity-increment-btn"
    );
    incrementButtons.forEach((button) => {
      button.disabled = this.currentBundleQuantity >= this.maxBundleQuantity;
    });

    // Mettre à jour le message dans le bloc_step
    const remainingProductsMessage = document.getElementById(
      "remaining-products-message"
    );
    if (remainingProductsMessage) {
      if (remaining > 0) {
        let remainingText =
          window.themeVariables.strings
            .packBuilderRemainingFragranceToChooseSingular;
        if (remaining > 1) {
          remainingText =
            window.themeVariables.strings
              .packBuilderRemainingFragranceToChoosePlural;
        }
        remainingText = remainingText.replace("%quantity%", remaining);
        remainingProductsMessage.classList.remove("all-selected");
        remainingProductsMessage.innerHTML = `
          <!-- Icône SVG pendant la progression -->
          <svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-plus" viewBox="0 0 12 12">
            <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="2"></path>
          </svg>
          ${remainingText}
        `;
      } else {
        remainingProductsMessage.classList.add("all-selected");
        remainingProductsMessage.innerHTML = `
          <!-- Icône SVG une fois tous les parfums choisis -->
          <svg aria-hidden="true" focusable="false" fill="none" width="13" class="icon icon-success" viewBox="0 0 13 9">
            <path fill="none" d="M1 4l4 4 7-7" stroke="currentColor" stroke-linecap="square"></path>
          </svg>
          ${window.themeVariables.strings.packBuilderAllFragrancesSelected}
        `;
      }
    }

    // Mettre à jour la jauge de progression
    this.updateProgressBar();
  }

  toggleAddToCartButton() {
    if (this.currentBundleQuantity === this.maxBundleQuantity) {
      this.addToCartButton.classList.remove("disabled");
      this.disableAddButtons(true);
    } else {
      this.addToCartButton.classList.add("disabled");
      this.disableAddButtons(false);
    }
    if (this.addToCartButton.dataset.priceInButton === "true") {
      this.addToCartButton.innerHTML = `${
        window.themeVariables.strings.addToCart
      } | ${this.getPriceHtml(this.bundleComparePrice, this.bundlePrice)}`;
    } else {
      this.addToCartButton.innerHTML = `${window.themeVariables.strings.addToCart}`;
    }
  }



  disableAddButtons(disable) {
    document.querySelectorAll(".add-to-selection-btn").forEach((button) => {
      button.classList.toggle("disabled", disable);
    });
  }

  updateProgressBar() {
    const percentage =
      (this.currentBundleQuantity / this.maxBundleQuantity) * 100;
    this.progressBarFill.style.width = `${percentage}%`;
    this.progressBarMarker.textContent = this.currentBundleQuantity;
    this.progressBarMarker.style.left = `${Math.max(
      0,
      Math.min(100, percentage)
    )}%`;
  }

  setLoadingState(isLoading) {
    this.addToCartButton.disabled = isLoading;
    this.addToCartButton.classList.toggle("loading", isLoading);
    this.addToCartButton.innerHTML = isLoading
      ? `${window.themeVariables.strings.addingToCart}`
      : `${window.themeVariables.strings.addToCart} | ${this.formatPrice(
          this.bundlePrice
        )}€`;
  }

  resetSelection() {
    this.currentBundleQuantity = 0;
    this.selectedItemsSummary.innerHTML = "";
    this.productCards.forEach((card) => this.resetProductCard(card));
    this.updateInterface();
    this.showToast(window.themeVariables.strings.packBuilderResetedSelection);
  }

  showToast(message) {
    const toast = document.createElement("div");
    toast.className = "toast-message";
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }

  updateProductCardStyle(productCard, isSelected) {
    if (isSelected) {
      productCard.classList.add("product-card-selected");
    } else {
      productCard.classList.remove("product-card-selected");
    }
  }

  // 🆕 Méthode d'attente adaptative pour le deployer-auto-add
  async waitForProcessing(deployerElement, maxWait = 3000) {
    const startTime = Date.now();
    
    // 🔥 ÉTAPE 1: Attendre d'abord 600ms pour que le setTimeout(500ms) du deployer expire
    console.log('⏳ Attente initiale de 600ms pour que le deployer commence...');
    await new Promise(resolve => setTimeout(resolve, 600));
    
    // 🔥 ÉTAPE 2: Maintenant surveiller quand isProcessing devient true puis false
    let processingStarted = false;
    const maxCheckTime = startTime + maxWait;
    
    while (Date.now() < maxCheckTime) {
      if (deployerElement.isProcessing) {
        processingStarted = true;
        console.log('✅ Deployer traitement commencé, attente de la fin...');
      } else if (processingStarted) {
        // Le traitement était en cours et maintenant il est terminé
        console.log('🎯 Deployer traitement terminé !');
        break;
      }
      
      // Vérifier toutes les 100ms
      await new Promise(resolve => setTimeout(resolve, 100));
    }
    
    // 🔥 ÉTAPE 3: Délai de sécurité supplémentaire
    await new Promise(resolve => setTimeout(resolve, 200));
    
    console.log(`🏁 Deployer processing completed in ${Date.now() - startTime}ms`);
  }
}

window.addEventListener("load", () => {
  if (localStorage.getItem("openDrawer") === "true") {
    localStorage.removeItem("openDrawer");
    document.getElementById("cart-drawer-header").click();
  }

  const trackEvent = localStorage.getItem("trackAddToCartEvent");
  if (trackEvent) {
    const { eventName, eventData } = JSON.parse(trackEvent);
    eventConsole(eventName, eventData);
    localStorage.removeItem("trackAddToCartEvent");
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 768) {
    document.querySelector(".summary-content").style.display = "none";
    document.querySelector(
      ".summary-content-block .bloc_step h4"
    ).style.display = "none";
  }
  new BundleManager();
});

window.addEventListener("resize", () => {
  const summaryContent = document.querySelector(".summary-content");
  const summaryTitle = document.querySelector(
    ".summary-content-block .bloc_step h4"
  );

  if (window.innerWidth > 768) {
    summaryContent.style.display = "block";
    if (summaryTitle) summaryTitle.style.display = "block";
  } else {
    summaryContent.style.display = "none";
    if (summaryTitle) summaryTitle.style.display = "none";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function moveProductListForMobile() {
    const productListWrapper = document.getElementById("product-list-wrapper");
    const selectionStep2 = document.getElementById("selection-step-2");

    if (window.innerWidth <= 768) {
      if (selectionStep2 && productListWrapper) {
        selectionStep2.insertAdjacentElement("afterend", productListWrapper);
      }
    } else {
      const bundleContainer = document.getElementById("bundle-container");
      if (bundleContainer && productListWrapper) {
        bundleContainer.insertBefore(
          productListWrapper,
          bundleContainer.firstChild
        );
      }
    }
  }

  moveProductListForMobile();
  window.addEventListener("resize", moveProductListForMobile);
});
